import React, { useState } from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';
import { useTranslation } from 'react-i18next';

const ContactInfoSection = ({
  email,
  phone,
  onEmailChange,
  onPhoneChange,
  errors = {}
}) => {
  const { t } = useTranslation();
  const [showEmailVerification, setShowEmailVerification] = useState(false);
  const [originalEmail] = useState(email);

  const emailChanged = email !== originalEmail;

  const handleEmailChange = (value) => {
    onEmailChange(value);
    if (value !== originalEmail) {
      setShowEmailVerification(true);
    } else {
      setShowEmailVerification(false);
    }
  };

  const formatPhoneNumber = (value) => {
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length <= 1) {
      return cleaned;
    } else if (cleaned.length <= 4) {
      return `+1 (${cleaned.slice(1)}`;
    } else if (cleaned.length <= 7) {
      return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4)}`;
    } else {
      return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7, 11)}`;
    }
  };

  const handlePhoneChange = (value) => {
    const formatted = formatPhoneNumber(value);
    onPhoneChange(formatted);
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
          <Icon name="Mail" size={20} className="text-green-600" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-gray-800">
            {t("contactInformation")}
          </h2>
        </div>
      </div>

      <div className="space-y-6">
        <div>
          <Input
            label={t("email")}
            type="email"
            value={email}
            onChange={(e) => handleEmailChange(e.target.value)}
            required
            error={errors.email}
          />
        </div>

        <div>
          <Input
            label={t("phone")}
            type="tel"
            value={phone}
            onChange={(e) => handlePhoneChange(e.target.value)}
            required
            error={errors.phone}
          />
        </div>
      </div>
    </div>
  );
};

export default ContactInfoSection;
